// extracted by mini-css-extract-plugin
export default {"container":"App_container__nBsNm","app":"App_app__KgJp9","spinner":"App_spinner__pb6EV","message":"App_message__p4pOU","previous":"App_previous__APc8x","poem":"App_poem__G1KxG"};